import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import RichTextEditor from 'react-rte'; 
import { Button, Intent } from '@blueprintjs/core';
import SelectScopeOfWorkModal from 'components/Quote/SelectScopeOfWorkModal';

@inject('store', 'quoteStore') @observer
class ProposalCoverEditor extends Component {

  @observable value = RichTextEditor.createValueFromString('Jasdeep Singh Narang', 'html');

  componentDidMount() {
    let {
      quoteStore: {
        quote: {
          object
        }
      }
    } = this.props;
    if (!object.attributes.proposal_markup) {
      this.value = RichTextEditor.createValueFromString(`
          <p><strong>Re: </strong></p>
        `, 'html');
    } else {
      this.value = RichTextEditor.createValueFromString(object.attributes.proposal_markup,'html');
    }
  }

  onChange(val) {
    let {
      quoteStore: {
        quote: {
          object
        }
      }
    } = this.props;

    this.value = val;
    object.attributes.proposal_markup = val.toString('html');
  }

  handleClosSelectScopeOfWorkModal() {
    this.props.store.isOpenScopeOfWorkDialog = false;
  }

  onSuccessSelectScopeOfWorkModal(scopeOfWork) {
    this.value = RichTextEditor.createValueFromString(scopeOfWork,'html');
    this.props.store.isOpenScopeOfWorkDialog = false;
  }

  render() {
    let {
      quoteStore: {
        quote: {
          object
        }
      }
    } = this.props;
    return(
      <div className="editor-nd" style={{ marginLeft: 10, marginRight: 10, marginBottom: 12 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8}}>
          <h5>
            <strong>Scope of Work</strong>
          </h5>
          <Button
            text={"Select Scope of Work Template"}
            intent={Intent.PRIMARY}
            onClick={() => {this.props.store.isOpenScopeOfWorkDialog = true;}} 
          />
        </div>
        <RichTextEditor
          value={this.value}
          onChange={this.onChange.bind(this)}
          className='text-editor'
          placeholder="Scope of Work" />

        <SelectScopeOfWorkModal
          isOpen={this.props.store.isOpenScopeOfWorkDialog}
          onClose={this.handleClosSelectScopeOfWorkModal.bind(this)}
          onSuccess={this.onSuccessSelectScopeOfWorkModal.bind(this)}
          warningRequired={object.attributes.proposal_markup != ""}
        />
      </div>
    )
  }

};

export default ProposalCoverEditor;